// extracted by mini-css-extract-plugin
module.exports =  {"roleList":"roleList--5g18J5r2sntw3ZU7e2D2rg=="};